import { Link, useNavigate } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import { useEffect, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import { ADMIN_CMS_SOCIAL_MEDIA } from "../../../../action/apiPath";
import { CallWithAuth } from "../../../../action/apiActions";
import { showToast } from "../../../../util/toastHelper";
import arrorRight from "../../../../assets/img/arrow-right.svg";
import { ADMINSOCIALMEDIAADD, ADMINSOCIALMEDIAUPDATE, ADMINSOCIALMEDIAPAGE } from "../../../../util/path";
import Loading from "react-fullscreen-loading";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminSocialMedia = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [socialMedia, setSocialMedia] = useState([]);

    useEffect(() => {
        getSocialMedia();
    }, []);

    const getSocialMedia = async () => {
        setIsLoading(true);
        try {
            setIsLoading(true);
            const response = await CallWithAuth("GET", ADMIN_CMS_SOCIAL_MEDIA);
            if (response.res.status == 200) {
                setSocialMedia(response?.res?.data?.data);
            } else {
                showToast("error", response.res.data.message);
            }
            setIsLoading(false);
        } catch (err) {
            const errorMessage = err?.response?.data?.message || err?.message || "Unexpected error occurred";
            showToast("error", errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        const result = await MySwal.fire({
            title: "Are you sure want to delete this social media?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });
        if (result.isConfirmed) {
            setIsLoading(true);
            try {
                const response = await CallWithAuth("DELETE", `${ADMIN_CMS_SOCIAL_MEDIA}/${id}`);
                if (
                    response?.res?.data?.statusCode === 200 ||
                    response?.res?.data?.statusCode === 201
                ) {
                    showToast("success", "Social media has been deleted successfully");
                    getSocialMedia();
                } else {
                    showToast("error", response?.res?.data?.message);
                }
            } catch (error) {
                showToast("error", "Something went wrong while deleting social media.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {isLoading && (
                <>
                    <Loading
                        loading
                        background="rgba(236, 240, 241, 0.7)"
                        loaderColor="#3498db"
                    />
                </>
            )}
            <div>
                <section className="site_hero patient_management_banner">
                    <div className="site_container">
                        <div className="site_row">
                            <div className="txt_colm">
                                <div className="txt_block">
                                    <h1>Manage Social Media</h1>
                                    <p>Manage each social media efficiently</p>
                                    {/* <div className="btn_row">
                                        <Link
                                            to={`${ADMINSOCIALMEDIAADD}`}
                                            className="solid_cta cta_primary cta_with_icon"
                                        >
                                            <span>Add Social Media</span> <img src={arrorRight} alt="" />
                                        </Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className="img_colm">
                                <div className="img_block">
                                    <img src={patient} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="site_container">
                    <div className="patient_form_block bg_light_gray my-4">
                        <div className="table-responsive">
                            <table className="table patient-row-details m-0">
                                <thead>
                                    <tr>
                                        <th width="15%">Platform</th>
                                        <th width="15%">URL</th>
                                        <th width="15%">Active?</th>
                                        <th width="10%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {socialMedia.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.platform}</td>
                                            <td>{item.url}</td>
                                            <td>{item.is_active ? 'Yes' : 'No'}</td>
                                            <td className="text-center d-flex gap-3 justify-content-center">
                                                <button
                                                    onClick={() => {
                                                        navigate(`${ADMINSOCIALMEDIAUPDATE}/${item.id}`, {
                                                            state: {
                                                                socialMedia: {
                                                                    platform: item.platform,
                                                                    url: item.url,
                                                                    is_active: item.is_active
                                                                }
                                                            }
                                                        })
                                                    }}
                                                    className="edit"
                                                >
                                                    <i className="fa-solid fa-info"></i>
                                                </button>
                                                {/* <button
                                                    onClick={() => handleDelete(item.id)}
                                                    className="edit"
                                                >
                                                    <i className="fa-solid fa-trash"></i>
                                                </button> */}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>


                            {socialMedia.length > 0 == 0 && (
                                <h1 style={{ textAlign: "center" }}>No social Found</h1>
                            )}
                        </div>
                    </div>
                </section>
            </div>
            <ToastContainer />
        </>
    );
};
export default AdminSocialMedia;
